import { render, staticRenderFns } from "./CadastrarEditarTermoDialog.vue?vue&type=template&id=55e1f220"
import script from "./CadastrarEditarTermoDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarTermoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports